export const primary = "#001E6C";
export const secondary = "#F2A51A"; //orange - F2A51A , yellow - FCD900
export const accent = "#163172";
export const background = "#ffffff";
export const edge = "#5F9DF7";
